/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  ConfigureProduct.tsx
 *
 * Project Title :  Checkout
 *
 * Description	 :
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Sivateja.P(H27743)
 *
 * @Date	     : Jul 29, 2019
 *
 * @Version      : Version 1.0
 *
 * By            : Sivateja (H267743)
 * On            : Aug 08, 2019
 * Description   : API Class for configure product related services.
 *
 * By            : Sivateja (H267743)
 * On            : Aug 14, 2019
 * Description   : Integrated Save to Cart Service (ASDS-909)
 *
 * By            : Sivateja (H267743)
 * On            : Aug 14, 2019
 * Description   : Moved the saveProducttoCart object mapping logic to configure-product-actions (ASDS-1048)
 *
 * By            : Deepthi Bachu (E844276)
 * On            : Sep 18, 2019
 * Description   : Updated the code to get products features list from ADS (ASDS-1283)
 *
 * By            : H224423
 * On            : Sep 30, 2019
 * Description   : ASDS-412 Edit cart details changes
 *
 * By            : Madhu Gali - H175591
 * On            : 18 Oct 2019
 * Description   : ASDS-1549
 *
 * By            : H224423
 * On            : 24 Oct 2019
 * Description   : ASDS-1256
 *
 * By            : H175591
 * On            : 01 Nov 2019
 * Description   : ASDS-588
 *
 * By            : H422335
 * On            : 14 Oct 2020
 * Description   : ASDS-3035 Migration of DCE Endpoints to new Forge Environment API
 *
 * By            : H422335
 * On            : 27 Oct 2020
 * Description   : ASDS-3269 Migration of DCE Endpoints to new Forge Environment API
 * Description   : ASDS-3035,ASDS-3823 Migration of DCE Endpoints to new Forge Environment API
 *
 * By            : H422337
 * On            : 03 Nov 2020
 * Description   : ASDS-3824 - Migration of DCE Endpoints to new Forge Environment API and UI enhancements of Phase-2
 *
 ******************************************************************************/
import API from './api';
import { CheckoutServiceURL } from '../constants/checkout-constants';
import { handleResponse, handleError } from './apiUtils';

class ConfigureProductAPI {

    static async getProductFeatureList(productId: string, soldTo: string): Promise<any> {
        const soldto = '?soldTo=' + soldTo;
        let data = await API.get(`${CheckoutServiceURL.GET_PRODUCT_FEATURE_LIST_URL}${productId}/sub-products/${soldto}`)
        .then(handleResponse)
        .catch(handleError);
        return data;
    }

    /**
     * calls read excel configuration API
     * @param productId
     * @param soldTo
     * @param data
     */
    static async readExcelConfiguration (productId: string, soldTo: string, data: any): Promise<any> {
    // static async readExcelConfiguration (productId: string, data: any): Promise<any> {
        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        };
        const formData = new FormData();
        formData.append('file', data);

        // const response = await API.post (`${CheckoutServiceURL.READ_EXCEL_CONFIGURATION}?productId=${productId}&soldTo=${soldTo}`, formData, config);
        const response = await API.post (`${CheckoutServiceURL.READ_EXCEL_CONFIGURATION}/${productId}/read-configurations?soldTo=${soldTo}`, formData, config);
        return response;
    }
}

export default ConfigureProductAPI;